const firebaseConfig = {
    apiKey: "AIzaSyA4VmPn2uiCFfZSsaQprnTdGsFKqY_4-xg",
    authDomain: "assign-11-tourism.firebaseapp.com",
    projectId: "assign-11-tourism",
    storageBucket: "assign-11-tourism.appspot.com",
    messagingSenderId: "657804489242",
    appId: "1:657804489242:web:b9d7c64a1b84890e64d7a3"
};

export default firebaseConfig;